// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-flip-counter';

export const Component = () => (
  <path d='M9.2 18H6.93v-5H2v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-9H9.2v5zM11 2H3a1 1 0 0 0-1 1v9h4.93v-1.2L7 9.67c-.37.38-.64.62-.78.74L5 11.4 3.89 10l3.45-2.71H9.2V12H12V3a1 1 0 0 0-1-1zm11 0h-8a1 1 0 0 0-1 1v9h5.86a3.93 3.93 0 0 0 .52-.86 2.41 2.41 0 0 0 .16-.84 1.21 1.21 0 0 0-.36-1 1.36 1.36 0 0 0-.95-.3 2.78 2.78 0 0 0-1.23.31 6.06 6.06 0 0 0-1.22.82l-1.21-1.46a8 8 0 0 1 1.31-1A4.71 4.71 0 0 1 17 7.29a5.81 5.81 0 0 1 1.37-.15 4.19 4.19 0 0 1 1.78.36 2.86 2.86 0 0 1 1.19 1c.292.446.449.967.45 1.5 0 .475-.087.947-.26 1.39a5.1 5.1 0 0 1-.29.57H23V3a1 1 0 0 0-1-1zm-3.2 12.7L17.42 16v.11h4.67V18H14.6v-1.57l2.69-2.72L18 13h-5v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-9h-2.49c-.38.43-.94 1-1.71 1.7z' />
);

export const viewBox = '0 0 25 25';
